import * as React from 'react'
import { usePanzoom } from '../use-panzoom'

export const PanzoomWrapper: React.FC = (props) => {
	const { children } = props
	const { PanzoomWrapper, panzoomRef, wrapperProps } = usePanzoom({
		bounds: true,
        boundsPadding: .6,
        minZoom: 0.4,
        maxZoom: 1
	})
	return (
		<PanzoomWrapper wrapperProps={wrapperProps} style={{ width: '100%', height: '100%' }}>
			<div ref={panzoomRef} style={{ display: 'inline-flex' }}>
				{children}
			</div>
		</PanzoomWrapper>
	)
}
